import { call, takeLatest, put } from 'redux-saga/effects';
import { addToRootSaga } from 'store';
import { fetchGoalMetrics } from 'api/IterableGoalsAPI';

import { Saga } from 'custom-types/saga';
import { GoalContributionsByMediumAction, QueryData } from 'modules/iterableGoals/types';
import { addNegativeToast, errorIdentifier } from 'modules/toastContainer';
import { getCommonTranslations } from 'utils/translations';
import * as actions from '../actions';
import { ActionTypes } from '../actionTypes';

export function* fetchGoalContributionsByMediumSaga({
  queryData,
}: GoalContributionsByMediumAction<{
  queryData: QueryData;
}>): Saga<GoalContributionsByMediumAction> {
  try {
    const metricsResponse = yield call(fetchGoalMetrics, queryData);
    yield put(actions.fetchGoalContributionsByMediumResponse(metricsResponse.data));
  } catch (error) {
    const errorMessage = yield call(getCommonTranslations, 'errorMessage.contactCSM');

    yield put(actions.fetchGoalContributionsByMediumError());
    yield put(
      addNegativeToast(
        errorMessage,
        errorIdentifier({
          source: 'fetchGoalContributionsByMediumSaga',
          error,
          additional: queryData,
        }),
      ) as any,
    );
  }
}

addToRootSaga([
  takeLatest(ActionTypes.FETCH_CONTRIBUTIONS_BY_MEDIUM_REQUEST, fetchGoalContributionsByMediumSaga),
]);
